import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PendingTakeoverContextType {
  pendingCount: number;
  updatePendingCount: (count: number) => void;
}

const PendingTakeoverContext = createContext<PendingTakeoverContextType | undefined>(undefined);

export const usePendingTakeover = () => {
  const context = useContext(PendingTakeoverContext);
  if (context === undefined) {
    throw new Error('usePendingTakeover must be used within a PendingTakeoverProvider');
  }
  return context;
};

interface PendingTakeoverProviderProps {
  children: ReactNode;
}

export const PendingTakeoverProvider: React.FC<PendingTakeoverProviderProps> = ({ children }) => {
  const [pendingCount, setPendingCount] = useState(0);

  const updatePendingCount = (count: number) => {
    setPendingCount(count);
  };

  const value = {
    pendingCount,
    updatePendingCount,
  };

  return (
    <PendingTakeoverContext.Provider value={value}>
      {children}
    </PendingTakeoverContext.Provider>
  );
};